<template>
  <div class="deals-display">
    <div class="filters-container flex-start gap-xl flex-wrap l:hidden margin-2xl-bottom">
      <div class="filter-block flex gap-l">
        <div class="filter-item">
          <form-input
            v-model="ordering"
            icon="arrows-sort"
            type="select"
            :list="orderings"
            :label="false"></form-input>
        </div>
      </div>

      <div v-if="internalCategory" class="filter-block flex gap-l">
        <div class="filter-item category-filter">
          <div class="field">
            <div class="field__controls">
              <icon
                icon="clone"
                class="field__icon l:hidden"
                :size="1.2"
                theme="gray"
                @click="isCategoryFilterOpened = !isCategoryFilterOpened"></icon>
              <div class="field__element">
                <div
                  class="cursor-pointer"
                  @click="isCategoryFilterOpened = !isCategoryFilterOpened">
                  <span>Category : {{ internalCategory.name }} </span>
                </div>

                <div
                  v-if="!isCategoryFilterOpened"
                  class="category-dropdown animate__fadeIn animate--fast">
                  <!-- parent link -->
                  <saffron-link
                    v-if="internalCategory.Parent"
                    class="parent-category"
                    :to="{
                      name: 'store-categories-cid-deals',
                      params: { cid: internalCategory.Parent.id },
                    }">
                    <block class="parent-category">
                      <span>
                        {{ internalCategory.Parent.name }}
                      </span>
                    </block>
                  </saffron-link>
                  <block class="current-category">
                    <span>{{ internalCategory.name }}</span>
                  </block>

                  <ul
                    v-if="
                      internalCategory.directChildren &&
                      internalCategory.directChildren.length > 0
                    ">
                    <li v-for="subCategory of internalCategory.directChildren">
                      <saffron-link
                        :to="{
                          name: 'store-categories-cid-deals',
                          params: { cid: subCategory.id },
                        }">
                        <icon-text icon="chevron-inline-end">{{
                          subCategory.name
                        }}</icon-text>
                      </saffron-link>
                    </li>
                  </ul>
                </div>
              </div>
              <icon
                v-if="isCategoryFilterOpened"
                icon="chevron-down"
                class="field__icon field__icon--end"
                theme="gray"
                @click="isCategoryFilterOpened = !isCategoryFilterOpened"></icon>
              <icon
                v-else
                icon="chevron-inline-end"
                class="field__icon field__icon--end"
                theme="gray"
                @click="isCategoryFilterOpened = !isCategoryFilterOpened"></icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-area flex gap-max flex-nowrap">
      <div
        class="filters-container filters-container--side l:visible flex-start flex-column gap-2xl flex-wrap">
        <div class="filter-block flex flex-column gap-s">
          <h6 class="filter-title l:visible margin-remove">
            {{ translateUcFirst("justopp.deals.orderControlTitle") }}
          </h6>
          <div class="filter-item">
            <form-input
              v-model="ordering"
              icon="arrows-sort"
              type="select"
              :list="orderings"
              :label="false"></form-input>
          </div>
        </div>

        <div v-if="internalCategory" class="filter-block flex flex-column gap-s">
          <h6 class="filter-title l:visible margin-remove">
            {{ translateUcFirst("justopp.deals.categoryControlTitle") }}
          </h6>
          <div class="filter-item category-filter">
            <div class="field">
              <div class="field__controls">
                <icon
                  icon="clone"
                  class="field__icon l:hidden"
                  :size="1.2"
                  theme="gray"></icon>
                <div class="field__element">
                  <div
                    class="cursor-pointer l:hidden"
                    @click="isCategoryFilterOpened = !isCategoryFilterOpened">
                    <span>{{ internalCategory.name }} </span>
                  </div>

                  <div
                    v-if="isCategoryFilterOpened"
                    class="category-dropdown animate__fadeIn animate--fast">
                    <!-- parent link -->
                    <saffron-link
                      v-if="internalCategory.Parent"
                      class="parent-category"
                      :to="{
                        name: 'store-categories-cid-deals',
                        params: { cid: internalCategory.Parent.id },
                      }">
                      <block class="parent-category">
                        <span>
                          {{ internalCategory.Parent.name }}
                        </span>
                      </block>
                    </saffron-link>
                    <block class="current-category">
                      <span>{{ internalCategory.name }}</span>
                    </block>

                    <ul
                      v-if="
                        internalCategory.directChildren &&
                        internalCategory.directChildren.length > 0
                      ">
                      <li v-for="subCategory of internalCategory.directChildren">
                        <saffron-link
                          :to="{
                            name: 'store-categories-cid-deals',
                            params: { cid: subCategory.id },
                          }">
                          <icon-text icon="chevron-inline-end">{{
                            subCategory.name
                          }}</icon-text>
                        </saffron-link>
                      </li>
                    </ul>
                  </div>
                </div>
                <icon
                  v-if="!isCategoryFilterOpened"
                  icon="chevron-down l:hidden"
                  class="field__icon field__icon--end cursor-pointer"
                  theme="gray"
                  @click="isCategoryFilterOpened = !isCategoryFilterOpened"></icon>
                <icon
                  v-else
                  icon="chevron-inline-end"
                  class="field__icon field__icon--end cursor-pointer l:hidden"
                  theme="gray"
                  @click="isCategoryFilterOpened = !isCategoryFilterOpened"></icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="relative items-container flex gap-l flex-wrap margin-auto-horizontal">
        <div
          v-if="asyncStatus.asyncDataLoading"
          class="loading-container flex-center flex-middle">
          <spinner :size="6"></spinner>
        </div>
        <h2 v-if="!asyncStatus.asyncDataLoading && !finalDeals">
          {{ translateTitleCase("justopp.deals.dealFetchError") }}
        </h2>
        <h2 v-if="!asyncStatus.asyncDataLoading && finalDeals && finalDeals.length < 1">
          {{ translateTitleCase("justopp.deals.noDealsFound") }}
        </h2>

        <deal-intro
          v-for="deal in finalDeals"
          v-if="!asyncStatus.asyncDataLoading && finalDeals && finalDeals.length > 0"
          :product="deal"
          style="flex: 0 0 250px"></deal-intro>
      </div>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { computed } from "vue";

export default {
  middleware: {},
  props: {
    category: {
      type: [Object, Boolean],
      default: false,
    },
    filters: {
      type: Object,
      default: {},
    },
  },
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data() {
    let rootCategoryId = computed(() => {
      let filterRoot = this.filters.anyChildOf ? this.filters.anyChildOf : null;
      return false;
    });

    const shuffle = (array) => {
      if (!config.justopp.deals.shuffleDealsInList) {
        return array;
      }
      let currentIndex = array.length;
      let randomIndex;

      while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex],
          array[currentIndex],
        ];
      }

      return array;
    };

    const asyncDataConfig = {
      rawDeals: {
        target: "justopp/deals",
        data: computed(() => this.dealListData),
        options: {
          dataMutator: (deals) => {
            if (config.justopp.deals.shuffleDealsInList) {
              return { ...deals, items: shuffle(deals.items) };
            } else {
              return { ...deals, items: (deals.items) };
            }
          },
        },
      },
    };

    if (!this.category && this.filters.anyChildOf) {
      asyncDataConfig.internalCategoryData = {
        target: computed(() => `justopp/categories/${this.filters.anyChildOf}`),
        options: {
          dataMutator: (input) => {
            if (input && input.item) {
              return input.item;
            } else {
              return false;
            }
          },
        },
      };
    }

    if (!this.category && this.filters.anyChildOf === "root") {
      asyncDataConfig.internalCategoryData = {
        target: computed(() => `justopp/categories/productsRoot`),
        options: {
          dataMutator: (input) => {
            if (input && input.item) {
              return input.item;
            } else {
              return false;
            }
          },
        },
      };
    }

    // TODO: handle root. how do we now root category? server maybe?
    return {
      isCategoryFilterOpened: true,
      rawDeals: false,
      localFilters: {},
      ordering: { key: "id", direction: "desc" },
      rootCategoryId: computed(() => {
        let filterRoot = this.filters.anyChildOf ? this.filters.anyChildOf : null;
        return false;
      }),
      internalCategoryData: false,
      orderings: [
        { value: { key: "id", direction: "desc" }, label: "justopp.deals.orderings.id" },
        {
          value: { key: "startingPrice", direction: "asc" },
          label: "justopp.deals.orderings.startingPriceAsc",
        },
        {
          value: { key: "startingPrice", direction: "desc" },
          label: "justopp.deals.orderings.staringPriceDesc",
        },
        {
          value: { key: "price", direction: "asc" },
          label: "justopp.deals.orderings.priceAsc",
        },
        {
          value: { key: "price", direction: "desc" },
          label: "justopp.deals.orderings.priceDesc",
        },
        {
          value: { key: "endDateTime", direction: "asc" },
          label: "justopp.deals.orderings.endDateTimeAsc",
        },
        {
          value: { key: "endDateTime", direction: "desc" },
          label: "justopp.deals.orderings.endDateTimeDesc",
        },
      ],
      asyncData: asyncDataConfig,
    };
  },
  computed: {
    dealListData() {
      let res = {
        pagination: {
          start: 0,
          limit: 99999,
        },
        filters: {
          country: this.sg("user.profile.country"),
          onlyLive: true,
          ...this.filters,
          ...this.localFilters,
          //the commented out filters are supported
          // "category":"16",
          // "parentCategory" : "4",
        }, // the commented out orderings are supported
        ordering: this.ordering,

        //{ key: "id", direction: "desc" },
        //{"key":"startingPrice","direction":"asc"}
        //{"key":"startingPrice","direction":"desc"}
        //{"key":"price","direction":"asc"}
        //{"key":"price","direction":"desc"}
        //{"key":"endDateTime","direction":"asc"}
        //{"key":"endDateTime","direction":"desc"}
        //{"key":"endDateTime","direction":"desc"}
      };

      let userProfile = this.sg("user.profile");
      if (!userProfile?.isSuperAdmin && !userProfile?.Vendor) {
        res.filters.country = this.sg("user.profile")?.country;
      }

      return res;
    },
    finalDeals() {
      if (!this.rawDeals) {
        return false;
      }

      if (this.rawDeals?.items) {
        return this.rawDeals.items;
      }

      return false;
    },
    internalCategory() {
      if (this.internalCategoryData) {
        return this.internalCategoryData;
      } else {
        return this.category;
      }
    },
    rootCategoryId() {
      let filterRoot = this.filters.anyChildOf ? this.filters.anyChildOf : null;
      return false;
    },
  },
  watch: {},
  created() {},
  mounted() {},
  serverPrefetch() {
    return this.getSSRPrefetchPromise();
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.deals-display {
  // display: flex;
  // gap: var(--margin-2xl);
  // align-items: stretch;
}

.filters-container {
  &.filters-container--side {
    flex-direction: column;
    flex: 0 0 250px;
    .filter-block {
      flex: 0;
      width: 100%;
    }

    .filter-item {
      width: 100%;
      flex: 100%;
    }
  }

  @media (max-width: 1024px) {
    .filter-block,
    .filter-item {
      flex: 400px;
      max-width: 400px;
      margin-inline: auto;
    }
  }
}

.items-container {
  // in production, the container overflows. It makes no sense. But thats how it is.
  // this is a fix for that issue
  max-width: calc(100% - 310px);
  display: flex;
  gap: var(--margin-2xl);
  flex-wrap: wrap;
  justify-content: space-around;

  @media (max-width: 1024px) {
    justify-content: center;
    max-width: 100%;
  }
}

.category-filter {
  min-width: 200px;

  .field__element {
    padding: 0.55em 2em !important;
  }

  .field__icon {
    top: 1.2em !important;
  }

  // desktop unique appearance
  @media (min-width: 767px) {
    .field__controls {
      border: none !important;
    }
    .field__element {
      padding: var(--margin-m) 0 0 0 !important;
    }

    .current-category {
    }

    .category-dropdown {
      padding-top: 0 !important;
    }
  }

  // small mobile width adjustment
  @media (max-width: 500px) {
    min-width: 150px;
  }

  .category-dropdown {
    padding-top: var(--margin-l);

    .parent-category {
      margin-bottom: var(--margin-m);
    }

    .current-category {
      padding-inline-start: 15px;
      margin-bottom: var(--margin-m);
    }

    ul {
      padding-inline-start: 30px;
      list-style: none;
      margin-top: 0;

      li {
        padding: 0;
        margin-bottom: var(--margin-m);
      }
    }
  }
}
</style>
